<template>
    <adaptive-modal
        name="remove-shape"
        :hide-action-buttons="true"
        title="Information"
        method="delete"
        @before-open="beforeOpen"
        @hide="canEditShape = false"
    >
        <div v-if="shape">
            <ul class="list-reset">
                <li>
                    <span class="font-bold">Typ:</span>
                    {{ shape.meta.type }}
                </li>
                <li class="mt-sm">
                    <span class="font-bold">Pris:</span>
                    {{ formatPrice(shape.meta.price) }}
                </li>
                <li v-if="shape.meta.distance > 0" class="mt-sm">
                    <span class="font-bold">Längd:</span>
                    {{ shape.meta.distance }}m
                </li>
            </ul>

            <div class="flex justify-between my-2xl">
                <button class="btn btn-lg is-danger is-ghost" @click="$emit('removedShape', shape)">
                    Ta bort
                </button>

                <button
                    v-if="canEditShape"
                    class="btn btn-lg is-ghost"
                    @click="edit"
                >
                    Redigera sträcka
                </button>
            </div>

            <h1 class="m-0 pb-lg text-md border-t pt-lg">Kommentarer</h1>
            <div v-if="comments && ! comments.length" class="mb-lg">
                <span>Bli den första att kommentera...</span>
            </div>
            <comments
                name="comments"
                ref-type="App\Modules\CriticalMoment\CriticalMomentItem"
                :ref-id="criticalMomentId"
                :comments="comments"
                :can-post="true"
                rows="3"
            />
        </div>
    </adaptive-modal>
</template>
<script>
    export default {
        data() {
            return {
                shape: null,
                canEditShape: false,
                criticalMomentId: null,
                comments: [],
            };
        },
        methods: {
            beforeOpen(obj) {
                this.shape = obj.params.shape;
                this.comments = (this.shape && this.shape.comments) ? this.shape.comments : [];
                this.criticalMomentId = this.shape.meta.id;

               if (this.shape instanceof google.maps.Polyline) {
                   this.canEditShape = true;
               }
            },
            edit() {
                this.$emit('editShape', this.shape);
                this.$modal.hide('remove-shape');
            },
            formatPrice(price) {
                const formatter = new Intl.NumberFormat('sv-SE', {
                    style: 'currency',
                    currency: 'SEK',
                    currencyDisplay: 'symbol',
                    minimumFractionDigits: 0,
                });

                return formatter.format(price);
            },
        },
    };
</script>
